import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function MiniTroopersWhatTheyLearn() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2551">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2552">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-2553">
          <div data-id="element-2554">
            <h2 className="text-4xl text-ink mb-8" data-id="element-2555">
              Building a Foundation for Success
            </h2>
            <p className="text-lg text-gray-warm mb-8" data-id="element-2556">
              Our Mini Troopers class isn't just about kicking and punching.
              It's about teaching young children how to learn, how to interact
              with others, and how to control their bodies.
            </p>
            <ul className="flex flex-col gap-4" data-id="element-2557">
              {['Listening and following directions', 'Focus and attention span', 'Balance and body coordination', 'Respect for teachers and peers', 'Sharing and taking turns on the mat', 'Stranger awareness and basic safety'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-lg text-ink font-medium" data-id="element-2558">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-2559" />
                  <span data-id="element-2560">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-2561">
            <h3 className="text-2xl text-ink mb-4" data-id="element-2562">Class Schedule</h3>
            <div className="flex items-center justify-between p-4 bg-paper rounded-xl border border-subtle-gray mb-4" data-id="element-2563">
              <span className="font-bold text-ink" data-id="element-2564">Monday – Friday</span>
              <span className="bg-subtle-gray/50 px-3 py-1 rounded-lg text-ink font-bold" data-id="element-2565">
                4:30 PM – 5:00 PM
              </span>
            </div>
            <p className="text-sm text-gray-warm text-center" data-id="element-2566">
              Classes are 30 minutes long - the perfect duration for preschool
              attention spans.
            </p>
          </div>
        </div>
      </div>
    </section>;
}